import { convertLocaleForGoogleMap } from 'src/utils/map';
type Props = {
  longitude: string;
  latitude: string;
  width: string;
  height: string;
  locale: string | undefined;
  title?: string;
};

export const GoogleMap: React.FC<Props> = ({
  longitude,
  latitude,
  width,
  height,
  locale,
  title = 'Google Map'
}: Props) => {
  return (
    <iframe
      width={width}
      height={height}
      title={title}
      src={`https://www.google.com/maps?q=${latitude},${longitude}&hl=${convertLocaleForGoogleMap(locale)}&z=15&output=embed`}
    />
  );
};
